import { createAction } from 'redux-actions';

export const setCurrentNotification = createAction('SET_CURRENT_NOTIFICATION');
export const searchNotifications = createAction('SEARCH_NOTIFICATIONS');
export const searchNotificationsMassive = createAction('SEARCH_NOTIFICATIONS_MASSIVE');
export const loadAllNotifications = createAction('LOAD_ALL_NOTIFICATIONS');
export const loadAllNotificationsMassive = createAction('LOAD_ALL_NOTIFICATIONS_MASSIVE');
export const filterNotifications = createAction('FILTER_NOTIFICATIONS');
export const paginateNotifications = createAction('PAGINATE_NOTIFICATIONS');
export const paginateNotificationsMassive = createAction('PAGINATE_NOTIFICATIONS_MASSIVE');
export const changeSortConfigNotification = createAction('CHANGE_SORT_CONFIG_NOTIFICATION');
export const changeSortConfigNotificationMassive = createAction(
  'CHANGE_SORT_CONFIG_NOTIFICATION_MASSIVE'
);
export const getAttachs = createAction('GET_ATTACHS');
export const removeAttach = createAction('REMOVE_ATTACH');
export const getCurrentItemId = createAction('GET_CURRENT_ITEM_ID');
export const saveAlert = createAction('SAVE_ALERT');
export const setClearNotificationsList = createAction('SET_CLEAR_NOTIFICATIONS_LIST');
export const setClearNotificationsMassiveList = createAction(
  'SET_CLEAR_NOTIFICATIONS_MASSIVE_LIST'
);
export const refreshNotifications = createAction('REFRESH_NOTIFICATIONS');
export const setAll = createAction('SET_ALL');
export const setMassiveAll = createAction('SET_MASSIVE_ALL');
export const getSaveFile = createAction('GET_SAVE_FILE');
export const removeDocumentFile = createAction('REMOVE_DOCUMENT_FILE');
export const setCollapseNotify = createAction('SET_COLLAPSE_NOTIFY');
export const goBackBasicData = createAction('GO_BACK_BASIC_DATA');
export const setShowTypeNotifications = createAction('SET_SHOW_TYPE_NOTIFICATIONS');
